import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";

// LegalPage: shared shell for /privacy and /terms. Keeps both pages visually
// consistent and centralizes typography, anchor links, and the "last updated"
// header. Children should be raw <section>…</section> blocks.
const LegalPage = ({ kicker, title, updated, version, children, otherLabel, otherTo }) => {
  return (
    <div className="min-h-screen bg-mm-parchment bg-topo flex flex-col">
      <Navbar />
      <div className="container mx-auto py-12 max-w-3xl flex-1 w-full" data-testid="legal-page">
        <div className="text-xs uppercase tracking-[0.22em] font-bold text-mm-steel">{kicker}</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-black text-mm-navy mt-2">{title}</h1>
        <div className="mt-3 flex flex-wrap items-center gap-3 text-sm text-mm-navy/70">
          <span>Last updated: <strong className="text-mm-navy">{updated}</strong></span>
          <span aria-hidden="true">·</span>
          <span>Version <span className="font-mono">{version}</span></span>
          {otherLabel && otherTo && (
            <>
              <span aria-hidden="true">·</span>
              <Link to={otherTo} className="text-mm-steel font-bold hover:text-mm-navy underline-offset-4 hover:underline">
                Read the {otherLabel}
              </Link>
            </>
          )}
        </div>

        <article className="mt-8 stage-card p-8 sm:p-10 bg-white space-y-7 text-mm-navy leading-relaxed">
          {children}
        </article>

        <p className="mt-6 text-xs text-mm-navy/55">
          This document was prepared in good faith based on how Mind Map operates today. It does not replace legal advice — if you have questions about your rights, please consult an attorney.
        </p>
      </div>
    </div>
  );
};

// Section is a small helper so headings/anchors stay consistent.
export const LegalSection = ({ id, title, children }) => (
  <section id={id} className="scroll-mt-24">
    <h2 className="font-heading text-xl sm:text-2xl font-black text-mm-navy">{title}</h2>
    <div className="mt-3 space-y-3 text-[15px] text-mm-navy/85">{children}</div>
  </section>
);

export const LegalLi = ({ children }) => (
  <li className="ml-5 list-disc">{children}</li>
);

export default LegalPage;
